import modalAddStandardSlice from "./modalAddStandardSlice";
import articleStandardSlice from "./articleStandardSlice";
import precommandeSlice from "./precommandeSlice";
import specialAddModalSlice from "./specialAddModalSlice";
import specialArticleSlice from "./specialArticleSlice";
import preOrderFilterSlice from "./preOrderFilterSlice";
import saveSpecialArticleSlice from "./saveSpecialArticleSlice";
import preordersSlice from './preordersSlice';

export const preOrderReducers = {
  modalAddStandardSlice,
  articleStandardSlice,
  specialAddModalSlice,
  specialArticleSlice,
  preOrderFilterSlice,
  saveSpecialArticleSlice,
  preordersSlice,
  precommandeSlice,
};
